module.exports = __webpack_public_path__ + "img/icon_left_3.e1f7470a.png";